import { useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import {
  selectBrand,
  selectCustomer,
  verifyAccount,
  selectVerifyAccount,
  sendCustomerVerificationEmail,
  useAppDispatch,
  useAppSelector,
} from '@open-tender/cloud'
import {
  ButtonLink,
  Content,
  HeaderDefault,
  Loading,
  Main,
  PageTitle,
  PageContainer,
  PageContent,
  Text,
} from 'components'

const VerifyAccount = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const { hash } = useLocation()
  const verifyToken = hash.includes('#') ? hash.split('#')[1] : ''
  const { auth } = useAppSelector(selectCustomer)
  const title = 'Verify Account'
  const { title: siteTitle, tpls } = useAppSelector(selectBrand) || {}
  const { success, loading, error } = useAppSelector(selectVerifyAccount)
  const { detail: errMsg } = error || {}

  useEffect(() => {
    if (!verifyToken || tpls) {
      return navigate('/account')
    } else {
      dispatch(verifyAccount(verifyToken))
    }
  }, [verifyToken, tpls, navigate, dispatch])

  const retryVerifyAccount = async () => {
    const linkUrl = `${window.location.origin}/verify`
    dispatch(sendCustomerVerificationEmail(linkUrl))
  }

  return (
    <>
      <Helmet>
        <title>
          {title} | {siteTitle}
        </title>
      </Helmet>
      <Content>
        <HeaderDefault />
        <Main>
          <PageContainer>
            {success ? (
              <>
                <PageTitle
                  title="Success! Your account has been verified."
                  subtitle="Please head back to your account or close this page and pick up where you left off."
                />
                <PageContent>
                  <div>
                    <p>
                      <ButtonLink
                        onClick={() => navigate(auth ? '/account' : '/guest')}
                      >
                        {auth
                          ? 'Head back to your account'
                          : 'Head back to the home page'}
                      </ButtonLink>
                    </p>
                  </div>
                </PageContent>
              </>
            ) : errMsg ? (
              <>
                <PageTitle
                  title="Something went wrong"
                  subtitle="Please review the error message below."
                />
                <PageContent>
                  <Text color="error" as="p">
                    {errMsg}.
                  </Text>
                  <p>
                    {auth ? (
                      <ButtonLink onClick={retryVerifyAccount}>
                        Click here to give it another try.
                      </ButtonLink>
                    ) : (
                      'Log into your account and visit your profile page to give it another try.'
                    )}
                  </p>
                </PageContent>
              </>
            ) : loading === 'pending' ? (
              <Loading text="Verifying your account. Please sit tight." />
            ) : null}
          </PageContainer>
        </Main>
      </Content>
    </>
  )
}

export default VerifyAccount
